// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationPageConversation = require("./ConversationPageConversation.bs.js");
let ConversationPageSelectedConversationHeader = require("./ConversationPageSelectedConversationHeader.bs.js");
let ConversationPageSelectedConversationContext = require("./ConversationPageSelectedConversationContext.bs.js");
let ConversationPageSelectedConversationMatches = require("./ConversationPageSelectedConversationMatches.bs.js");
let ConversationPageSelectedConversationAnonymousControl = require("./ConversationPageSelectedConversationAnonymousControl.bs.js");
let ConversationPageSelectedConversationDisplayer_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationDisplayer_conversation_graphql.bs.js");

let convertFragment = ConversationPageSelectedConversationDisplayer_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

let ConversationFragment_conversationVisibilityV5_decode = ConversationPageSelectedConversationDisplayer_conversation_graphql.Utils.conversationVisibilityV5_decode;

let ConversationFragment_conversationVisibilityV5_fromString = ConversationPageSelectedConversationDisplayer_conversation_graphql.Utils.conversationVisibilityV5_fromString;

let ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationDisplayer(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, props.conversation);
  let router = Next.useRouter();
  let match = conversation.conversationContext;
  let tmp;
  if (match !== undefined) {
    let fragmentRefs = match.fragmentRefs;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ConversationPageSelectedConversationContext.make, {
            conversationContext: fragmentRefs
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ConversationPageSelectedConversationMatches.make, {
            conversationContext: fragmentRefs
          })
        })
      ]
    });
  } else {
    tmp = null;
  }
  let match$1 = conversation.visibility;
  let tmp$1;
  tmp$1 = match$1 === "PUBLIC" ? JsxRuntime.jsx("div", {
      children: "This conversation is public.",
      className: "border bg-amber-50 p-4 mx-4"
    }) : null;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "arrow-left",
              size: 16,
              className: "inline-block"
            }),
            className: "lg:hidden p-2",
            type: "button",
            onClick: param => Next.Router.replace("/conversations", undefined, undefined, router)
          }),
          JsxRuntime.jsx(ConversationPageSelectedConversationHeader.make, {
            conversation: conversation.fragmentRefs
          })
        ],
        className: "bg-gray-100 lg:bg-transparent p-4 lg:p-0 border-b lg:border-b-0 flex flex-row space-x-2 items-center"
      }),
      tmp,
      tmp$1,
      JsxRuntime.jsx(ConversationPageSelectedConversationAnonymousControl.make, {
        conversation: conversation.fragmentRefs,
        conversationId: conversation.id
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationPageConversation.make, {
          conversation: conversation.fragmentRefs
        })
      })
    ],
    className: "lg:p-4 flex flex-col space-y-4"
  });
}

let make = ConversationPageSelectedConversationDisplayer;

exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Next Not a pure module */
